import { Tabs } from "@jana-technology/platform-ui";
import {
  RISK_ROUTE_CHARTS,
  RISK_ROUTE_CHARTS_MITIGATION_SEGMENT,
  RISK_ROUTE_CHARTS_OVERALL_SEGMENT,
  RISK_ROUTE_TABLES,
} from "constants/routing";
import { useGlobalFiltersContext } from "contexts/filters";
import { useOutcomeScenariosContext } from "contexts/scenarios";

import { useNavTabsFromHandle } from "hooks/useNavTabsFromHandle";
import { generatePath } from "react-router-dom";

export const RiskManagementNavTabs = () => {
  const { primaryTabs, secondaryTabs, primaryDefaultTab, secondaryDefaultTab } =
    useNavTabsFromHandle();

  const { wellIdNameParam, appliedRiskMitigationId } =
    useGlobalFiltersContext();

  const { selectedScenario } = useOutcomeScenariosContext();

  // for now, only show outcome scenarios when a risk mitigation is not applied

  return primaryTabs ? (
    <div className="flex justify-between">
      <div className="flex">
        <Tabs
          asNav
          className="uppercase"
          items={primaryTabs.map((tab) => {
            if (tab.link?.includes(RISK_ROUTE_CHARTS)) {
              // does not preserve /major/ route on unmount; not sure if needed yet
              return {
                ...tab,
                link: generatePath(
                  `${RISK_ROUTE_CHARTS}/${appliedRiskMitigationId ? RISK_ROUTE_CHARTS_MITIGATION_SEGMENT : RISK_ROUTE_CHARTS_OVERALL_SEGMENT}/${wellIdNameParam}`,
                ),
              };
            }

            // data table
            return {
              ...tab,
              link: generatePath(
                `${RISK_ROUTE_TABLES}/${selectedScenario ?? ""}`,
              ),
            };
          })}
          value={primaryDefaultTab}
        />
      </div>
      {secondaryTabs && !appliedRiskMitigationId && (
        <Tabs
          asNav
          kind="secondary"
          items={secondaryTabs}
          value={secondaryDefaultTab}
        />
      )}
    </div>
  ) : null;
};

export default RiskManagementNavTabs;
